const validate = (values) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  errors = {};

  if (!values.email) {
    errors.email = true;
  } else if (!emailRegex.test(values.email)) {
    errors.email = true;
  }

 /* ReactPasswordStrength component returns an object with
 the shape {score: number, isValid: boolean, password: string}. 
 If !isValid, the whole object is passed into 
 the validate function. If the form passes in a string, 
 password is valid. */
  if (typeof values.password !== "string") {
    errors.password = true;
  }

  if (!values.accepted) {
    errors.accepted = true;
  } else if (values.accepted !== true) {
    errors.accepted = true;
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/validate.js